import * as Constants from './constants';

export default function render() {
  // eslint-disable-next-line no-invalid-this
  const store = this;
  const mapExists = store.ctx.map && store.ctx.map.getSource(Constants.sources.HOT) !== undefined;
  if (!mapExists) return cleanup();

  const mode = store.ctx.events.currentModeName();

  store.ctx.ui.queueMapClasses({ mode });

  let newHotIds = [];
  let newColdIds = [];

  if (store.isDirty) {
    newColdIds = store.getAllIds();
  } else {
    newHotIds = store.getChangedIds().filter(id => store.get(id) !== undefined);
    newColdIds = store.sources.hot.filter(geojson => geojson.properties.id && newHotIds.indexOf(geojson.properties.id) === -1 && store.get(geojson.properties.id) !== undefined).map(geojson => geojson.properties.id);
  }


  store.sources.hot = [];
  const lastColdCount = store.sources.cold.length;
  store.sources.cold = store.isDirty ? [] : store.sources.cold.filter((geojson) => {
    const id = geojson.properties.id || geojson.properties.parent;
    return newHotIds.indexOf(id) === -1;
  });

  const coldChanged = lastColdCount !== store.sources.cold.length || newColdIds.length > 0;
  newHotIds.forEach(id => renderFeature(id, 'hot'));
  newColdIds.forEach(id => renderFeature(id, 'cold'));

  function renderFeature(id, source) {
    const feature = store.get(id);
    const featureInternal = feature.internal(mode);
    store.ctx.events.currentModeRender(featureInternal, (geojson) => {
      store.sources[source].push(geojson);
    });
  }


  /********************** cilc add *********************/
  /* if (newHotIds.length > 0 && store.sources.hot.length > 0) {
    if (store.getSelected()[0]) {
      //有select，feature编辑中
      store.ctx.map.fire('draw.liveEdit', { feature: store.getSelected()[0].toGeoJSON() })
    }
    else {
      //无select，绘制中
      if (coldChanged) {
        //store.ctx.map.fire('draw.liveDrawFinish', { feature: features[features.length - 1].toGeoJSON() })
        store.ctx.map.fire('draw.liveDrawFinish', { feature: store.get(store.getChangedIds()[0]).toGeoJSON() })
      }
      else {
        //store.ctx.map.fire('draw.liveDraw', { feature: features[features.length - 1].toGeoJSON() })
        store.ctx.map.fire('draw.liveDraw', { feature: store.get(store.getChangedIds()[0]).toGeoJSON() })
      }
    }
  } else if (coldChanged && store.getSelected().length === 0 && lastColdCount > 0 && store._emitSelectionChange) {
    const changeIds = store.getChangedIds(),
      changedFeature = store.get(changeIds[changeIds.length - 1])
    if (changedFeature)
      store.ctx.map.fire('draw.liveEditFinish', { feature: changedFeature.toGeoJSON() })
  } */

  /********************** finish **********************/

  if (coldChanged) {
    store.ctx.map.getSource(Constants.sources.COLD).setData({
      type: Constants.geojsonTypes.FEATURE_COLLECTION,
      features: store.sources.cold
    });
  }
  store.ctx.map.getSource(Constants.sources.HOT).setData({
    type: Constants.geojsonTypes.FEATURE_COLLECTION,
    features: store.sources.hot
  });

  if (store._emitSelectionChange) {
    store.ctx.map.fire(Constants.events.SELECTION_CHANGE, {
      features: store.getSelected().map(feature => feature.toGeoJSON()),
      points: store.getSelectedCoordinates().map(coordinate => ({
        type: Constants.geojsonTypes.FEATURE,
        properties: {},
        geometry: {
          type: Constants.geojsonTypes.POINT,
          coordinates: coordinate.coordinates
        }
      }))
    });
    store._emitSelectionChange = false;
  }

  if (store._deletedFeaturesToEmit.length) {
    const geojsonToEmit = store._deletedFeaturesToEmit.map(feature => feature.toGeoJSON());

    store._deletedFeaturesToEmit = [];

    store.ctx.map.fire(Constants.events.DELETE, {
      features: geojsonToEmit
    });
  }

  cleanup();
  store.ctx.map.fire(Constants.events.RENDER, {});

  function cleanup() {
    store.isDirty = false;
    store.clearChangedIds();
  }
}
